import dynamic from 'next/dynamic';
import Navbar, { NavbarProps } from '../../organism/Navbar';
import { useEffect, useState, useMemo, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { setUserData, setIsLoggedIn, setAuth } from 'ui/store/auth/actions';
import authService from 'ui/services/auth';
import { useSelector } from 'react-redux';
import authPageLists from 'ui/constants/authPageLists.json';
import useNativeDefaultProvince from '../../../hooks/useNativeDefaultProvince';
import useNativeGlobalLocation from '../../../hooks/useNativeGlobalLocation';
import { updateLocation } from '../../../services/geolocation';
import { IRootState } from '../../../store';
import { useRouter } from '../../../hooks/useCustomRouter';
import { step } from '../../organism/ModalBulkConfirmation/type';
import {
  SingleIdResponse,
  SingleIdVerificationPhoneNumber,
  TransactionAccount,
} from '../../../interface/login-modal.interface';
import getConfigDac from '../../../services/configDac';
import { getGlobalCart } from '../../../services/orderPlacement';
import loyaltyService from '../../../services/loyalty';
import singleIdService from '../../../services/singleId';
import Footer from '../../organism/Footer';
import eventSuccessLogin from 'ui/lib/gtm/eventSuccessLogin';
import { trackLogin } from 'ui/lib/gtm-es/user-identification/trackLogin';
import Cookies from 'js-cookie';
import { setAstrapointsValue, setIsLoyaltyProgramActive } from '../../../store/loyalty/action';
import AnimationSuccess from 'ui/assets/images/AnimationSuccessBookingService.gif';
import useUuPdp from '../../../hooks/useUuPdp';
import eventViewSuccessHubungkanLoyalty from '../../../lib/gtm/eventLoyaltyDigiroom/eventViewSuccessHubungkanLoyalty';
import isO2OProfileHelper from '../../../helpers/utils/isEligibleO2OProfileSync';
import CheckPermissionNotification from '../../molecules/CheckPermissionNotification';
import {
  setGlobalCartEntries,
  setGlobalCartTotalCartCount,
} from '../../../store/globalCart/actions';
import LazyRecaptchaProvider from 'ui/components/atoms/RecaptchaProvider';
import useSetHardwerdId from '../../../hooks/emarsys/global/useSetHardwerdId';
import EmarsysHead from '../../atoms/EmarsysHead';
import { emarsysFirstTimePush, emarsysLogout, emarsysReload } from '../../../helpers/emarsys/utils';
import { submitModalService } from '../../../services';
import useRedirectPopupAdds from '../../../hooks/useRedirectPopupAdds ';

const TanyaTasia = dynamic(() => import('ui/components/atoms/TanyaTasia'), { ssr: false });
const ModalBulkConfirmation = dynamic(() => import('../../organism/ModalBulkConfirmation'), {
  ssr: false,
});
const ModalConfirmation = dynamic(() => import('../../molecules/ModalConfirmation'), {
  ssr: false,
});
const ModalGlobalConfirmation = dynamic(() => import('../../molecules/GlobalConfirmationModal'), {
  ssr: false,
});
const DeeplinkPopUp = dynamic(() => import('../../molecules/DeeplinkPopUp'), {
  ssr: false,
});

const PopUpAdsAaf = dynamic(() => import('../../molecules/PopUpAdsAaf'), {
  ssr: false,
});
const Loading = dynamic(() => import('../../molecules/Loading'), {
  ssr: false,
});

const PUBLIC_URL = process.env.NEXT_PUBLIC_URL;
const SHOW_POP_UP_EVENT_TEST_DRIVE =
  process.env.NEXT_PUBLIC_SHOW_POP_UP_EVENT_TEST_DRIVE === 'TRUE';

interface LayoutProps {
  children: React.ReactNode;
  isHideNavbar?: boolean;
  isHideFooter?: boolean;
  tasiaClassName?: string;
  isNativeView?: boolean;
  backToTopClassName?: string;
  withFooter?: boolean;
  showTasia?: boolean;
  navbarProps?: NavbarProps;
  footerRef?: React.MutableRefObject<HTMLDivElement | null>;
  onSubmitCity?: (submit: {
    province?: string;
    isocode?: string;
    city?: string;
    allCity?: string[];
    cityIso?: string;
  }) => void;
  reloadWhenLocationChange?: boolean;
  badgeBottomHeight?: string;
  showButtonBack?: boolean;
  backTitle?: string;
  customBackURL?: string;
  isUsingDefaultAnchor?: boolean;
  withGlobalCartReentries?: boolean;
  withGlobalCartFetch?: boolean;
  auto2000FooterLogoMobileClassName?: string;
  withRecaptchaV3?: boolean;
  footerImpressionData?: {
    title: string;
    section: string;
  };
  isHomepage?: boolean;
  isShowTestDriveAAF?: boolean;
}

const Layout = ({
  children,
  isHideNavbar = false,
  tasiaClassName,
  isNativeView,
  backToTopClassName,
  withFooter = true,
  showTasia = true,
  navbarProps = {},
  footerRef = null,
  onSubmitCity,
  reloadWhenLocationChange = false,
  badgeBottomHeight,
  showButtonBack = false,
  backTitle,
  customBackURL,
  isUsingDefaultAnchor = false,
  withGlobalCartFetch = true,
  auto2000FooterLogoMobileClassName,
  withRecaptchaV3 = false,
  footerImpressionData,
  isHomepage = false,
  isShowTestDriveAAF = false,
}: LayoutProps) => {
  const RECAPTCHA_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_KEY_V3 ?? '';
  const router = useRouter();
  const isLoginPage = useMemo(
    () =>
      authPageLists?.includes(router?.pathname) &&
      !(
        router?.pathname === '/login' &&
        router?.query?.type === 'dac' &&
        router?.query?.uc &&
        router?.query?.transactionType
      ),
    [router?.pathname]
  );
  const auth = useSelector((state: IRootState) => state?.auth);
  const {
    popUpAdds: { isShown: isShownDeeplinkPopUp },
  } = useSelector((state: IRootState) => state?.page);

  const timero2o = Number(process.env.NEXT_PUBLIC_TIMER_O2O_SEAMLESS) || 4;

  const [visibleBulkModal, setVisibleBulkModal] = useState(false);
  const [steps, setSteps] = useState<step[]>([]);
  const [singleIdState, setSingleIdState] = useState<SingleIdVerificationPhoneNumber>({});
  const [singleIdData, setSingleIdData] = useState<SingleIdResponse>();
  const [isMatched, setIsMatched] = useState(false);
  const [seamlessDatadata, setSeamlessDatadata] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState({
    visible: false,
    title: '',
    content: (
      <Fragment>
        <img src={AnimationSuccess.src} className="w-[90px] h-auto my-6 mb-8" />
        <span className="mb-2"></span>
      </Fragment>
    ),
    ctaOnClick: () => {},
    setVisible: () => {
      setModalConfirmation((prev) => ({ ...prev, visible: false }));
    },
  });
  const [o2oProfileDisplayedState, setO2oProfileDisplayedState] = useState<
    {
      updatedDataField: string;
      currentData: string;
      newData: string;
    }[]
  >([]);
  const [transactionAccountList, setTransactionAccountList] = useState<TransactionAccount[]>([]);
  const [showTestDriveBanner, setShowTestDriveBanner] = useState(false);

  const { isGTMReady } = useSelector((state: IRootState) => state.dataGTM);
  const dispatch = useDispatch();
  useNativeDefaultProvince();
  useNativeGlobalLocation();
  useUuPdp({});
  const confirmationModalState = useSelector((state: IRootState) => state.confirmationModal);

  const fetchSystemAuth = async () => {
    await authService.getSystemAuth();
  };

  const fetchUserData = async () => {
    try {
      const response = await authService.getUserAuth();
      dispatch(setUserData(response?.data));
      localStorage?.setItem('userData', JSON?.stringify(response?.data));

      if (response?.data) {
        dispatch(setIsLoggedIn(true));

        if (isLoginPage) window.location.replace(process.env.NEXT_PUBLIC_URL);
      } else {
        dispatch(setIsLoggedIn(false));
        emarsysLogout();
      }
    } catch (err) {
      console.log(err);
      dispatch(setIsLoggedIn(false));
      emarsysLogout();
    }

    dispatch(setAuth(true));
  };

  const checkLoyaltyProgram = async () => {
    try {
      if (
        router.pathname.includes('success') ||
        router.pathname.includes('checkout') ||
        !auth.isLoggedIn
      ) {
        const loyaltyProgramResult = await loyaltyService.checkLoyaltyProgram();
        if (loyaltyProgramResult?.message === 'true') {
          dispatch(setIsLoyaltyProgramActive(true));
          dispatch(setAstrapointsValue(loyaltyProgramResult?.loyaltyRewardAmount));
        }
      } else {
        const [loyaltyProgramResult, AstrapointsResult] = await Promise.all([
          loyaltyService.checkLoyaltyProgram(),
          loyaltyService.getAstrapoints(),
        ]);
        if (loyaltyProgramResult?.message === 'true') {
          dispatch(setIsLoyaltyProgramActive(true));
          dispatch(setAstrapointsValue(loyaltyProgramResult?.loyaltyRewardAmount));
        }
        if (AstrapointsResult?.earnPointNotif) {
          if (window.location.pathname === '/') {
            eventViewSuccessHubungkanLoyalty({
              name: auth?.userData?.name.toLowerCase(),
              email: auth?.userData?.email.toLowerCase(),
              no_hp: auth?.userData?.phoneNumber
                ?.replace('+62', '0')
                .replace('62', '0')
                .replace(/\s/g, ''),
              astraPoint: AstrapointsResult?.earnPointNotif,
            });
            setModalConfirmation((prev) => ({
              ...prev,
              visible: true,
              title: 'Akun Anda Telah Berhasil Terhubung',
              content: (
                <Fragment>
                  <img src={AnimationSuccess.src} className="w-[90px] h-auto my-6 mb-8" />
                  <span>Selamat! Akun AstraPay Anda telah berhasil terhubung</span>
                  <span className="block p-2 mb-1 rounded bg-reliableBlack3">
                    Anda mendapat tambahan{' '}
                    <strong>{AstrapointsResult?.earnPointNotif} AstraPoint</strong> atas kelengkapan
                    Profil Digiroom Anda.
                  </span>
                </Fragment>
              ),
              ctaOnClick: () => {
                setModalConfirmation((prev) => ({ ...prev, visible: false }));
              },
              ctaTitle: 'KEMBALI',
              setVisible: () => {
                setModalConfirmation((prev) => ({ ...prev, visible: false }));
              },
              showCloseButton: false,
              hideCloseButton: true,
            }));
          } else {
            eventViewSuccessHubungkanLoyalty({
              name: auth?.userData?.name.toLowerCase(),
              email: auth?.userData?.email.toLowerCase(),
              no_hp: auth?.userData?.phoneNumber
                ?.replace('+62', '0')
                .replace('62', '0')
                .replace(/\s/g, ''),
              astraPoint: AstrapointsResult?.earnPointNotif,
            });
            setModalConfirmation((prev) => ({
              ...prev,
              visible: true,
              title: 'Akun Anda Telah Berhasil Terhubung',
              content: (
                <Fragment>
                  <img src={AnimationSuccess.src} className="w-[90px] h-auto my-6 mb-8" />
                  <span>Selamat! Akun AstraPay Anda telah berhasil terhubung</span>
                  <span className="block p-2 mb-1 rounded bg-reliableBlack3">
                    Anda mendapat tambahan <strong>5000 AstraPoint</strong> atas kelengkapan Profil
                    Digiroom Anda.
                  </span>
                </Fragment>
              ),
              ctaOnClick: () => {
                setModalConfirmation((prev) => ({ ...prev, visible: false }));
                window.location.href = PUBLIC_URL;
              },
              ctaTitle: 'KE BERANDA',
              setVisible: () => {
                setModalConfirmation((prev) => ({ ...prev, visible: false }));
              },
              showCloseButton: true,
              hideCloseButton: false,
            }));
          }
        }
      }
    } catch {
      dispatch(setIsLoyaltyProgramActive(false));
    }
  };

  useEffect(() => {
    try {
      const getData = async () => {
        const response = await getConfigDac.getConfigDac();
        if (response.status === 200) {
          // The response contains a 'value' field with the date in 'dd/mm/yyyy' format
          const configDac = response?.data;

          const [day, month, year] = configDac.value ? configDac.value.split('/') : [];
          const baseDate =
            day && month && year ? new Date(Number(year), Number(month) - 1, Number(day)) : null;
          if (!baseDate) {
            return;
          }
          const targetDate = new Date(baseDate);
          targetDate.setDate(targetDate.getDate());
          const today = new Date();

          // Set the hours, minutes, seconds, and milliseconds to 0 for both dates
          // to ensure they are treated as the same day
          targetDate.setHours(0, 0, 0, 0);
          today.setHours(0, 0, 0, 0);

          const isEqualOrAfter = today.getTime() >= targetDate.getTime();

          setIsMatched(isEqualOrAfter);
        }
      };
      getData();
    } catch (error) {
      console.log('Error fetching configDac:', error);
    }
  }, []);

  useEffect(() => {
    const currentSeamlessData = JSON.parse(sessionStorage.getItem('seamlessData') || 'null');
    if (!isMatched && auth?.isLoggedIn && currentSeamlessData === 'true') {
      return;
    }

    const checkSessionData = () => {
      if (currentSeamlessData?.value !== 'true') {
        return;
      }

      const isExpired =
        new Date().getTime() - new Date(currentSeamlessData?.date).getTime() > timero2o * 60 * 1000;

      if (isExpired && auth?.isLoggedIn) {
        setSeamlessDatadata(true);
        sessionStorage.removeItem('seamlessData');
      }
    };

    // Jalankan pengecekan langsung saat komponen pertama kali mount
    checkSessionData();

    // Atur interval untuk pengecekan berkala
    const intervalId = setInterval(checkSessionData, 60 * 1000);

    // Fungsi cleanup yang akan dipanggil saat komponen unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [auth.isLoggedIn]);

  const initModal = async () => {
    const steps: step[] = [];
    const uudpdConsent = sessionStorage.getItem('uupdp_consent');
    const currentSeamlessData = JSON.parse(sessionStorage.getItem('seamlessData') || 'null');
    const isSessionError = sessionStorage.getItem('errorSingleId') === 'true';
    // process here
    const pdp = () => {
      if (uudpdConsent === 'true') {
        steps.push('pdp');

        sessionStorage.removeItem('uupdp_consent');
      }
    };

    const alreadyClosed = sessionStorage.getItem('testDriveBannerClosed');
    try {
      const isTemporaryDAC = sessionStorage.getItem('after_login_temporary_dac') === 'true';
      const transactionAccount = await singleIdService.getTranscation(isTemporaryDAC);

      if (transactionAccount.acknowledge === 1 && transactionAccount.accounts.length > 0) {
        setTransactionAccountList(transactionAccount.accounts);
        steps.push('transaction');
        pdp();
      } else {
        const fetchSingleId = async () => {
          const singleIdResult = await singleIdService.getProfileAndVehicleO2O();

          const { verificationPhoneNumber } = singleIdResult;

          setSingleIdData({
            customer: singleIdResult.customer,
            profileTemporary: singleIdResult.profileTemporary,
            verificationPhoneNumber: singleIdResult.verificationPhoneNumber,
            dmcpVehicles: singleIdResult.dmcpVehicles,
          });
          setSingleIdState(verificationPhoneNumber);

          return singleIdResult;
        };

        let singleIdDataTemp: SingleIdResponse | null = null;

        const shouldFetch =
          (isMatched && currentSeamlessData?.value !== 'true' && !auth?.userData?.customerNoTDMS) ||
          (isMatched && auth?.userData?.customerNoTDMS) ||
          (!isMatched && auth?.userData?.customerNoTDMS) ||
          (!isMatched && currentSeamlessData !== 'true' && !auth?.userData?.customerNoTDMS);

        if (shouldFetch && !isSessionError) {
          singleIdDataTemp = await fetchSingleId();
        }

        if (!singleIdDataTemp) {
          await pdp();
          if (steps.length > 0) {
            steps.push('confirmation');
            setSteps(steps);
            setVisibleBulkModal(true);
          } else {
            sessionStorage.removeItem('after_register_redirect');
          }
          return;
        }

        if (
          singleIdDataTemp?.verificationPhoneNumber?.acknowledge === 0 &&
          singleIdDataTemp?.verificationPhoneNumber?.message?.toLocaleLowerCase() ===
            'rejected seamless' &&
          !currentSeamlessData?.value &&
          isMatched &&
          !auth?.userData?.customerNoTDMS
        ) {
          sessionStorage.setItem(
            'seamlessData',
            JSON.stringify({ value: 'true', date: new Date().toISOString() })
          );
        }

        const o2oprofile = async () => {
          const displayedFieldState = isO2OProfileHelper(
            auth?.userData,
            singleIdDataTemp.profileTemporary
          );
          const profileTemporaryIsNotEmpty =
            singleIdDataTemp?.profileTemporary &&
            Object.keys(singleIdDataTemp.profileTemporary).length > 0;
          if (profileTemporaryIsNotEmpty && displayedFieldState?.isEligibleO2oProfileSync) {
            setO2oProfileDisplayedState(displayedFieldState?.displayedFields);
            steps.push('o2oprofile');
          } else if (profileTemporaryIsNotEmpty && displayedFieldState.caseSensitiveDifference) {
            // modal does not appear here, but since there are differences in case sensitivity, we still submit the o2o profile
            sessionStorage.setItem('o2oprofilecasesensitiverif', 'true');
          }
        };

        const o2oCars = () => {
          if (
            singleIdDataTemp?.profileTemporary?.vehicle?.length > 0 ||
            singleIdDataTemp?.dmcpVehicles?.length > 0
          ) {
            steps.push('o2ocars');
          }
        };

        const haveCustomerNoTDMS = Boolean(auth?.userData?.customerNoTDMS);

        o2oCars();
        await o2oprofile();
        pdp();

        if (
          sessionStorage.getItem('o2oprofilecasesensitiverif') === 'true' &&
          !steps.includes('o2ocars') &&
          haveCustomerNoTDMS
        ) {
          await submitModalService.submitModal({
            type: 'autoseamlessubmit',
            data: {
              customerNoTDMS: auth?.userData?.customerNoTDMS,
              is020Sync: true,
            },
          });
          sessionStorage.removeItem('o2oprofilecasesensitiverif');
          await fetchUserData();
        }
      }

      // after process
      if (steps.length > 0) {
        steps.push('confirmation');
        setSteps(steps);
        setVisibleBulkModal(true);
      } else {
        sessionStorage.removeItem('after_register_redirect');
        if (!alreadyClosed && SHOW_POP_UP_EVENT_TEST_DRIVE) {
          setShowTestDriveBanner(isShowTestDriveAAF);
        }
      }
    } catch (error) {
      console.log({ error });
      if (!steps.includes('pdp')) {
        pdp();
      }
      // after process
      if (steps.length > 0) {
        steps.push('confirmation');
        setSteps(steps);
        setVisibleBulkModal(true);
      } else {
        sessionStorage.removeItem('after_register_redirect');
        if (!alreadyClosed && SHOW_POP_UP_EVENT_TEST_DRIVE) {
          setShowTestDriveBanner(isShowTestDriveAAF);
        }
      }
    }
  };

  useEffect(() => {
    const currentSeamlessData = JSON.parse(sessionStorage.getItem('seamlessData') || 'null');
    const dataTemp =
      currentSeamlessData?.value === undefined ? currentSeamlessData : currentSeamlessData?.value;
    const checkLoginPage = authPageLists?.includes(router?.pathname);

    if (auth.isLoggedIn && auth?.userData && (seamlessDatadata || !dataTemp) && !checkLoginPage) {
      initModal();
    }
  }, [auth.isLoggedIn, seamlessDatadata]);

  useEffect(() => {
    if (isGTMReady && auth?.isLoggedIn) {
      setTimeout(() => {
        const loginMethod = sessionStorage.getItem('loginMethod') || '';
        const phoneNumber = auth?.userData?.phoneNumber
          ?.replace('+62', '0')
          .replace('62', '0')
          .replace(/\s/g, ''); // please ensure this validity
        const email = auth?.userData?.email;

        if (sessionStorage.getItem('success_register_gtm')) {
          eventSuccessLogin('register', auth?.userData?.customerNo, loginMethod);
          trackLogin('registration', auth?.userData?.customerNo, loginMethod, phoneNumber, email);
          sessionStorage.removeItem('success_register_gtm');
          sessionStorage.removeItem('loginMethod');
        }

        if (sessionStorage.getItem('success_login_gtm')) {
          eventSuccessLogin('login', auth?.userData?.customerNo, loginMethod);
          trackLogin('login', auth?.userData?.customerNo, loginMethod, phoneNumber, email);
          sessionStorage.removeItem('success_login_gtm');
          sessionStorage.removeItem('loginMethod');
        }
      }, 1000);
    }
  }, [isGTMReady, auth]);

  const syncLocation = async () => {
    if (!localStorage?.getItem('city_name')) return;

    try {
      const response = await updateLocation({
        city_name: localStorage.getItem('city_name'),
        city_iso: localStorage.getItem('city_iso'),
        sync: true,
      });

      if (window?.location?.href?.includes('mobil-baru-toyota/p/') && response?.data?.isRefresh)
        router.reload();
    } catch {
      console.log('');
    }
  };

  useEffect(() => {
    if (auth.isAuth) {
      checkLoyaltyProgram();
    }
  }, [auth.isAuth]);

  function removeTradeInSessionStorageData() {
    const sessionLength = sessionStorage?.length;
    if (!sessionLength) return;
    for (let i = sessionLength - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith('tradein_')) {
        sessionStorage.removeItem(key);
      }
    }
  }

  useEffect(() => {
    emarsysFirstTimePush();
    fetchSystemAuth();
    fetchUserData();
    syncLocation();
    if (!router.pathname?.trim()?.endsWith('/tukar-tambah')) {
      removeTradeInSessionStorageData();
    }
    if (!router.pathname.includes('layanan-bengkel')) {
      sessionStorage.removeItem('FORM_WORKSHOP_SERVICE');
      if (router.query.slug !== 'layanan-bengkel') {
        Cookies.remove('CARTID_WORKSHOP_SERVICE');
      }
    }
    if (!router.pathname.includes('ths-home-service')) {
      sessionStorage.removeItem('FORM_HOME_SERVICE');
      if (router.query.slug !== 'ths-home-service') {
        Cookies.remove('CARTID_HOME_SERVICE');
      }
    }
    if (!router.pathname.includes('body-paint-service')) {
      sessionStorage.removeItem('FORM_BODY_PAINT');
      if (router.query.slug !== 'body-paint-service') {
        Cookies.remove('CARTID_BODY_PAINT');
      }
    }
    if (withGlobalCartFetch === true) {
      getGlobalCart(false).then((res) => {
        dispatch(setGlobalCartTotalCartCount(res?.data?.totalGlobalNonBundleUnitCount || 0));
        dispatch(setGlobalCartEntries(res?.data?.entries || []));
      });
    }
  }, []);

  useEffect(() => {
    emarsysReload();
  }, [router]);

  useSetHardwerdId();
  useRedirectPopupAdds();

  const renderLayout = () => {
    if (isShownDeeplinkPopUp) {
      // adds layout
      return (
        <>
          {!isNativeView && (
            <Navbar
              {...auth}
              {...navbarProps}
              onSubmitCity={onSubmitCity}
              reloadWhenLocationChange={reloadWhenLocationChange}
              isHideNavbar={isHideNavbar}
              showButtonBack={showButtonBack}
              backTitle={backTitle}
              customBackURL={customBackURL}
              isUsingDefaultAnchor={isUsingDefaultAnchor}
              isHomepage={isHomepage}
            />
          )}
          <DeeplinkPopUp />
          <main className={`bg-white`}>{children}</main>
        </>
      );
    } else {
      // general layout
      return (
        <LazyRecaptchaProvider
          load={withRecaptchaV3}
          reCaptchaKey={RECAPTCHA_KEY}
          strategy="lazyOnload"
        >
          <EmarsysHead />
          <CheckPermissionNotification />

          {!isNativeView && (
            <Navbar
              {...auth}
              {...navbarProps}
              onSubmitCity={onSubmitCity}
              reloadWhenLocationChange={reloadWhenLocationChange}
              isHideNavbar={isHideNavbar}
              showButtonBack={showButtonBack}
              backTitle={backTitle}
              customBackURL={customBackURL}
              isUsingDefaultAnchor={isUsingDefaultAnchor}
              isHomepage={isHomepage}
            />
          )}

          <main className={`bg-white`}>{children}</main>
          <div id="emarsys-zone" />
          <div id="emarsys-floating-menu" />
          <div id="placeholder_emarsys_1" />
          <div id="placeholder_emarsys_2" />
          <div id="placeholder_emarsys_3" />

          <ModalBulkConfirmation
            visible={visibleBulkModal}
            onClose={() => {
              setVisibleBulkModal(false);
              sessionStorage.removeItem('after_register_redirect');
              const alreadyClosed = sessionStorage.getItem('testDriveBannerClosed');
              if (!alreadyClosed && SHOW_POP_UP_EVENT_TEST_DRIVE) {
                setShowTestDriveBanner(isShowTestDriveAAF);
              }
            }}
            onOpen={() => setVisibleBulkModal(true)}
            steps={steps}
            singleIdData={singleIdData}
            singleIdState={singleIdState}
            isMatched={isMatched}
            displayedFieldsO2OProfile={o2oProfileDisplayedState}
            setSteps={setSteps}
            transactionAccountList={transactionAccountList}
          />
          <ModalConfirmation {...modalConfirmation} />
          <ModalGlobalConfirmation {...confirmationModalState} />
          <PopUpAdsAaf show={showTestDriveBanner} setShow={setShowTestDriveBanner} />
        </LazyRecaptchaProvider>
      );
    }
  };

  return (
    <>
      {renderLayout()}

      {!isNativeView && withFooter && (
        <Footer
          auto2000FooterLogoMobileClassName={auto2000FooterLogoMobileClassName}
          footerRef={footerRef}
          impressionData={footerImpressionData}
        />
      )}

      {showTasia && (
        <TanyaTasia
          tasiaClassName={tasiaClassName}
          backToTopClassName={backToTopClassName}
          badgeBottomHeight={badgeBottomHeight}
        />
      )}
    </>
  );
};

export default Layout;
